"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalBody = void 0;

var _preact = require("preact");

var ModalBody = function ModalBody(props) {
  return (0, _preact.h)("div", {
    id: "modal-description",
    className: "control-modal-body"
  }, props.children);
};

exports.ModalBody = ModalBody;